import school1 from "../../assets/history.png";

const History = () => {
    return (
        <div id="history" className="vision-card">
            <div className="about-intro-grid">
                <div className="about-text">
                    <h2>SCHOOL HISTORY</h2>
                    <p>
                        Nav Jeevan Mission School was founded in 1990 and is located in Kasia, Uttar Pradesh.
                    </p>
                    <p>
                        The school has always maintained an excellent holistic education and co -curriculum 
                        activities for its students.
                    </p>
                    <p>
                        It is a residential co-educational school, accommodates around 3500 students out of whom 500 are boarders. 
                        Our well-experienced team of teaching & non-teaching staff ensures that the young people entering 
                        the world turn out responsible citizens capable of steeing themselves and their country towards 
                        excellence.
                    </p>
                </div>

                <div className="about-img">
                    <img src={school1} alt="Nav Jeevan Mission School" />
                </div>
            </div>
        </div>


    );
};

export default History;